import React from 'react';
import { map, insertURLQuery } from '@libs/shared';
import { EMPTY_FN, URL_PARAMETER } from '~/constants';
import type CorpUserModel from '~/models/corpUser';
import { Hyperlink } from '@fx-ui/jdy-design-biz';

/**
 * 将消息内容转换为html
 *
 * @param content
 * @param onLinkClick
 * @param isShowLink
 * @param corpUser
 * @returns {string}
 */
export const parseMessage2Html = (
    content: any,
    onLinkClick = EMPTY_FN,
    isShowLink?: boolean,
    corpUser?: CorpUserModel
) => {
    if (!content) {
        return null;
    }
    const renderLink = () => {
        let link = content.link;
        if (link && content.linkText && isShowLink) {
            // 外链扩展字段添加用户ID
            if (/\/f\/[0-9a-f]{24}$/.test(link) && corpUser) {
                link = insertURLQuery(link, [{ key: URL_PARAMETER.EXT, value: corpUser.userId }]);
            }
            return (
                <Hyperlink
                    className="fx-message-link-btn"
                    href={link}
                    onClick={() => onLinkClick()}
                >
                    {content.linkText}
                </Hyperlink>
            );
        }
    };

    // 处理企业日志相关消息
    if (typeof content.content === 'string') {
        return (
            <span>
                {content.content}
                {renderLink()}
            </span>
        );
    }

    // 处理站内消息
    return (
        <p>
            {map(content.content, (el, index) => {
                switch (Number(index)) {
                    case 0:
                        return (
                            <span key={index}>
                                {el}
                                {renderLink()}
                                <br />
                            </span>
                        );
                    default:
                        return (
                            <span key={index}>
                                {el} <br />
                            </span>
                        );
                }
            })}
        </p>
    );
};
